import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import * as JSZip from 'jszip';
import { EXPORT_OPTIONS, functionToExportKey } from 'src-ironside/constants/export-product';
import { ExportResourceType } from 'src-ironside/enums/resource.enum';
import { ExportDataProductComponent } from 'src-ironside/new-product/export-data-product/export-data-product.component';
import { TranslateDynamicLanguageTablePipe } from 'src-ironside/pipes/translateDynamicLanguageTable.pipe';
import { Product, ProductExtendInfo, ProductRepository } from 'src-ironside/repositories/product.repository';
import { Resource } from 'src-ironside/repositories/resource.repository';
import { TariffRepository } from 'src-ironside/repositories/tariff.repository';
import { CommonService } from 'src-ironside/services/common.service';
import { PermissionService } from 'src-ironside/services/permission.service';
import { getSafeFilename, resetUsedFilenames } from 'src-ironside/utils/dowload-file-zip';
import { environment } from 'src/environments/environment.ironside';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-tabview-product',
    templateUrl: 'tabview-product.component.html',
    styleUrls: ['./tabview-product.component.css'],
    providers: [ProductRepository],
})
export class TabviewProductComponent {
    @ViewChild('tableInformationProduct') tableInformationProduct: ElementRef;
    @ViewChild('exportDataProduct') exportDataProduct: ExportDataProductComponent;
    productExtendInfo?: ProductExtendInfo[];
    selectedInfo: ProductExtendInfo;
    loading: boolean = false;
    visible: boolean = false;
    fileSelected: any = {
        url: '',
        type: '',
        fileName: '',
        origin: null,
    };
    loadingFile: boolean = false;
    pdfLoaded: boolean = false;
    defaultImg = 'src-ironside/assets/images/image-default.jpg';
    selectedChild: string[] = [];
    idProduct: string = '';
    exportOption = EXPORT_OPTIONS.filter((opt) => opt.key !== 'PHOTO_THUMBNAIL').map((opt) =>
        opt.key === 'PHOTO' ? { ...opt, label: 'PRODUCT_IMAGES' } : { ...opt },
    );
    @Input() set product(value: Product | undefined) {
        if (!value) return;

        const deniedTypes: ExportResourceType[] = [];
        const hasPermHr = this.permissionService.isPermissionFonction('export-photos-hd');
        const hasPermLr = this.permissionService.isPermissionFonction('export-photos-bd');

        Object.entries(this.exportResourcePermissionMap).forEach(([ref, type]) => {
            if (type === ExportResourceType.PHOTO) {
                if (!hasPermHr && !hasPermLr) deniedTypes.push(type);

                return;
            }
            if (!this.permissionService.isPermissionFonction(ref)) {
                deniedTypes.push(type);
            }
        });

        this.productExtendInfo = value.fullExtendData?.map((el) => {
            let filterResource = el.resources?.filter(
                (r) => r?.files && r?.status?.value === 'ACTIF',
            );

            // loại bỏ những resource có type nằm trong danh sách denied
            filterResource = filterResource?.filter(
                (r) => !deniedTypes.includes(r?.typeOfResource) && r.files?.[0]?.url,
            );

            return {
                ...el,
                resources: filterResource,
            };
        });

        this.idProduct = value.id || '';
        this.initActiveExport();
    }

    showDialog = false;
    dialogAdditionData: {
        loading: boolean;
        visible: boolean;
        data: Product[];
        index: number | null;
        titleDialog: string;
    } = {
        loading: false,
        visible: false,
        data: [],
        index: null,
        titleDialog: '',
    };
    indexLoading: number;

    constructor(
        private sanitizer: DomSanitizer,
        private datePipe: DatePipe,
        private translateDynamicLanguage: TranslateDynamicLanguageTablePipe,
        private router: Router,
        public permissionService: PermissionService,
        private _commonService: CommonService,
        private productRepository: ProductRepository,
        private dynamicDocumentService: DynamicDocumentService,
        private translate: TranslateService,
        private activatedRoute: ActivatedRoute,
    ) {}

    exportResourcePermissionMap: { [key: string]: ExportResourceType } = {
        'export-services-apres-vente': ExportResourceType.PI_SAV,
        'export-oeuvres-art': ExportResourceType.TI_ARTW,
        'export-informations-commerciales': ExportResourceType.PI_COM,
        'export-fiches-techniques': ExportResourceType.DATA_SHEET,
        'export-certificat-environnement': ExportResourceType.ENVIRONMENTAL,
        'export-vues-eclatees': ExportResourceType.TI_VIEW,
        'export-certificat-ironside': ExportResourceType.TI_CER_IR,
        'export-instruction-manual': ExportResourceType.PI_MAN,
        'export-autres-infos-produits': ExportResourceType.PI_INF,
        'export-autres-infos-techniques': ExportResourceType.TI_INF,
        'export-engagement-reach': ExportResourceType.REACH,
        'export-certificat-usine': ExportResourceType.TI_CER,
        'export-certificats-sociaux': ExportResourceType.SOCIAL,
        'export-ressource-pieces-detachees': ExportResourceType.TI_PART,
        'export-ressource-videos': ExportResourceType.VIDEO,
        'export-photos-hd': ExportResourceType.PHOTO,
        'export-photos-bd': ExportResourceType.PHOTO_THUMBNAIL,
        'export-rapport-essais': ExportResourceType.TI_REP,
    };

    ngOnInit() {}

    ngAfterViewInit() {}

    getHeight() {
        return this.tableInformationProduct?.nativeElement?.offsetHeight;
    }

    handleShowDialog(info: ProductExtendInfo): void {
        this.showDialog = true;
        this.selectedInfo = info;
    }

    closeDialog() {
        this.showDialog = false;
    }

    isCurrentDateInRange(info: ProductExtendInfo): boolean {
        const currentDate = Date.now();
        if (info?.newStartDate && info?.newEndDate && info?.new === true) {
            return currentDate >= info?.newStartDate && currentDate <= info?.newEndDate;
        }
        return false;
    }

    downloadFile(fileUrl: string, filename: string, resource?: any) {
        if (!fileUrl) return;
        this.loading = true;

        if (
            this.isIronside() &&
            this.productExtendInfo &&
            this.productExtendInfo[0] &&
            this.productExtendInfo[0].url &&
            this.productExtendInfo[0].url[0]
        ) {
            const info = this.productExtendInfo[0].url[0];

            const currentLang = localStorage.getItem('lang') ?? 'en';
            const locale =
                environment?.languagesExtranet?.find((l: any) => l.code == currentLang)?.locale ??
                'en_GB';

            let prefix: string = '';
            if (info.linkToProduct && info.linkToProduct.length > 0) {
                prefix += info.linkToProduct[0].value;
            }
            if (info.linkToPartner && info.linkToPartner.length > 0) {
                prefix += info.linkToPartner[0].value;
            }
            if (info.linkToSupplier && info.linkToSupplier.length > 0) {
                prefix += info.linkToSupplier[0].value;
            }
            if (info.typeOfResource) {
                try {
                    prefix += `-${info.typeOfResource.labels[locale]}`;
                } catch (e) {}
            }
            const extension: string = filename.substring(filename.lastIndexOf('.'));
            filename = `${prefix}${extension}`;
        }
        /* filename = decodeURIComponent(filename).toUpperCase().replace(/ /g, '-');
        filename = filename.replace(/["'&=$€*\/+\[\]{}|]/g, '-');
        const fileExtension = this.getFileExtensionFromUrl(fileUrl);
        const filenameResult = `${filename}.${fileExtension}`; */

        const title = resource?.files[0]?.url?.title;
        const fileNames = getSafeFilename(
            title || 'file',
            resource?.files[0]?.url,
            resource?.typeOfResource,
            resource?.referential,
        );
        fetch(fileUrl)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);

                const anchor = document.createElement('a');
                anchor.href = blobUrl;
                anchor.download = fileNames;
                anchor.click();
                this.loading = false;

                window.URL.revokeObjectURL(blobUrl);
            })
            .catch((error) => {
                this.loading = false;
                console.error('Error downloading file:', error);
            });
    }

    getFileExtensionFromUrl(url: string) {
        try {
            const pathname = new URL(url).pathname;
            const filename = pathname.split('/').pop();
            const extension = filename?.split('.').pop();

            return extension?.includes('?') ? extension.split('?')[0] : extension;
        } catch (error) {
            console.error('Invalid URL:', error);
            return '';
        }
    }

    private isIronside(): boolean {
        return environment.client === 'ironside';
    }

    downloadAllResource(info: ProductExtendInfo, index?: number) {
        if (index) {
            this.indexLoading = index;
        }

        // Reset danh sách tên file đã sử dụng trước khi bắt đầu download
        resetUsedFilenames();

        const resources = info?.resources?.filter((item: any) => item?.files?.[0]?.url) || [];
        if (resources.length === 0) return;

        if (resources?.length > 1) {
            this.loading = true;
            const zip = new JSZip();
            const filePromises: Promise<void>[] = [];
            let fileCount = 0;

            resources?.forEach((resource: any, resourceIndex: number) => {
                resource?.files?.forEach((file: any, fileIndex: number) => {
                    fileCount++;
                    const fileUrl = file?.url;
                    const typeOfResource = resource?.typeOfResource;
                    const referential = resource?.referential;
                    const filename = getSafeFilename(
                        fileUrl?.title || 'file',
                        fileUrl,
                        typeOfResource,
                        referential,
                    );

                    const filePromise = fetch(fileUrl)
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error(
                                    `Network response was not ok: ${response.status} ${response.statusText}`,
                                );
                            }
                            return response.blob();
                        })
                        .then((blob) => {
                            if (blob && blob.size > 0) {
                                zip.file(filename, blob);
                            }
                        })
                        .catch((error) => {
                            zip.file(`ERROR_${filename}`, 'File download failed');
                        });

                    filePromises.push(filePromise);
                });
            });

            Promise.all(filePromises)
                .then(() => {
                    // Kiểm tra xem có file nào bị lỗi không
                    const errorFiles = Object.keys(zip.files).filter((name) =>
                        name.startsWith('ERROR_'),
                    );
                    if (errorFiles.length > 0) {
                        console.warn('⚠️ Files with errors:', errorFiles);
                    }

                    zip.generateAsync({ type: 'blob' }).then((zipBlob: Blob) => {
                        const zipUrl = URL.createObjectURL(zipBlob);
                        const a = document.createElement('a');
                        a.href = zipUrl;
                        a.download = 'download.zip';
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(zipUrl);
                        this.loading = false;
                    });
                })
                .catch((error) => {
                    this.loading = false;
                });
        } else {
            this.loading = false;
            this.downloadFile(
                info?.resources?.[0]?.files?.[0]?.url,
                info?.resources?.[0]?.title ?? '',
                info?.resources?.[0],
            );
        }
    }

    onShowFile(resource: Resource) {
        const url = resource?.files?.[0]?.url;
        const fileExtension = this.getFileExtensionFromUrl(url);
        if (fileExtension === 'pdf') {
            this.loadingFile = true;
        }
        this.visible = true;
        this.fileSelected = {
            url: url,
            type: fileExtension ?? '',
            fileName: resource?.title,
            origin: resource,
        };

        setTimeout(() => {
            this.loadingFile = false;
        }, 3000);
    }

    pageComplete(_event: any) {
        //this.pdfLoaded = false;
    }

    pageRendered(_event: any) {
        //this.pdfLoaded = false;
        this.loadingFile = false;
    }

    /**
     * Description placeholder
     *Function Take Url Iframe
     * @param {*} value
     * @returns {*}
     */
    sanitizedUrl(value: string) {
        const googleViewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
            value,
        )}&embedded=true`;
        return this.sanitizer.bypassSecurityTrustResourceUrl(googleViewerUrl);
    }

    convertTariffs(tariffs?: any[]) {
        return (
            tariffs
                ?.filter((t: any) => t.price)
                ?.map((t: any) => {
                    const priceText = `${t.price.toFixed(2)} ${
                        t.currency ? TariffRepository.mapCurrencyText(t.currency) : ''
                    }`;

                    const startDate = t.applicationStartDate
                        ? this.datePipe.transform(t.applicationStartDate, 'dd-MM-yyyy')
                        : '';

                    const endDate = t.applicationEndDate
                        ? this.datePipe.transform(t.applicationEndDate, 'dd-MM-yyyy')
                        : '';

                    const dateText = [startDate, endDate].filter(Boolean).join(' / ') || '_';
                    const moq = t.moq ? `${t.moq}pcs` : '';
                    const incoterm =
                        this.translateDynamicLanguage.transform(t.incoterm?.labels) || '';
                    const typePackaging =
                        this.translateDynamicLanguage.transform(t.typeOfPackaging?.labels) || '';
                    const place = t.placeIncoterm || '';
                    const incotermText = [incoterm, place, moq, typePackaging]
                        .filter(Boolean)
                        .join(' ');

                    return [
                        priceText.trim(),
                        incotermText.trim(),
                        dateText.trim(),
                        t.linkToSupplier,
                    ];
                }) || []
        );
    }

    onRedirectToSupplier(supplier: string) {
        this.router.navigateByUrl(`suppliers/detail-supplier/${supplier}`);
    }

    isChildSelected(child: string): boolean {
        return this.selectedChild.includes(child);
    }

    toggleChildSelection(event: any, child: ProductExtendInfo) {
        if (event) {
            this.selectedChild.push(child.id!);
        } else {
            this.selectedChild = this.selectedChild.filter((id) => id !== child.id);
        }
        this.initActiveExport();
    }

    isAllSelected(childList: ProductExtendInfo[]): boolean {
        const ids = childList.map((c) => c.id).filter(Boolean);
        return ids.length > 0 && ids.every((id) => this.selectedChild.includes(id!));
    }

    isIndeterminate(childList: ProductExtendInfo[]): boolean {
        const ids = childList.map((c) => c.id).filter(Boolean);
        const selectedCount = ids.filter((id) => this.selectedChild.includes(id!)).length;
        return selectedCount > 0 && selectedCount < ids.length;
    }

    toggleSelectAll(checked: boolean, childList: ProductExtendInfo[]): void {
        const ids = childList.map((c) => c.id).filter(Boolean);
        if (checked) {
            this.selectedChild = [...ids] as string[];
        } else {
            this.selectedChild = this.selectedChild.filter((id) => !ids.includes(id));
        }
        this.initActiveExport();
    }

    /**
     * Load PHOTO resources from API to get hd field
     * Không transform data để giữ nguyên giá trị hd
     */
    async loadPhotoResourcesWithHd(productIds: string[]): Promise<any[]> {
        try {
            if (!productIds || productIds.length === 0) {
                return [];
            }

            const currentLocale =
                environment.languagesExtranet.find(
                    (lang) => lang.code === this.translate.currentLang,
                )?.locale || 'en_GB';

            const apiResponse = await firstValueFrom(
                this.dynamicDocumentService.listResourcesByProductIds(
                    [this.idProduct],
                    ['PHOTO'],
                    [currentLocale],
                    false,
                ),
            );

            // Không transform data để giữ nguyên giá trị hd
            return Array.isArray(apiResponse) ? apiResponse : apiResponse?.content || [];
        } catch (error) {
            console.error('Error loading PHOTO resources:', error);
            return [];
        }
    }

    /**
     * Lấy ID của product có referenceProduct khớp với URL
     * URL có dạng: product/detail/{referenceProduct}
     */
    getProductIdsByReferenceProduct(products: ProductExtendInfo[]): string[] {
        // Lấy referenceProduct từ URL params
        const routeParams = this.activatedRoute.snapshot.params;
        const referenceProductFromUrl = routeParams['id']; // referenceProduct từ URL

        if (!referenceProductFromUrl) {
            // Nếu không có trong URL, fallback về cách cũ
            return products.map((p: any) => p.id).filter((id): id is string => Boolean(id));
        }

        // Tìm product có referenceProduct khớp với URL
        const matchedProducts = products.filter((product: any) => {
            return product.referenceProduct === referenceProductFromUrl;
        });

        // Lấy IDs của các product khớp
        const productIds = matchedProducts
            .map((p: any) => p.id)
            .filter((id): id is string => Boolean(id));

        // Nếu không tìm thấy, fallback về cách cũ
        if (productIds.length === 0) {
            return products.map((p: any) => p.id).filter((id): id is string => Boolean(id));
        }

        return productIds;
    }

    async initActiveExport() {
        let selectedProducts: ProductExtendInfo[] = [];

        if (this.selectedChild?.length > 0) {
            selectedProducts =
                this.productExtendInfo?.filter((product: any) =>
                    this.selectedChild.includes(product.id),
                ) || [];
        } else {
            selectedProducts = this.productExtendInfo || [];
        }

        // Lấy resources từ fullExtendData cho các type khác PHOTO
        const allResources = selectedProducts
            .flatMap((product: ProductExtendInfo) => product.resources || [])
            .filter((res: any) => res?.files?.length);

        // Lấy product IDs dựa trên referenceProduct từ URL
        const productIds = this.getProductIdsByReferenceProduct(selectedProducts);

        // Gọi API để lấy PHOTO resources có trường hd
        const photoResourcesFromApi = await this.loadPhotoResourcesWithHd(productIds);

        if (allResources.length || photoResourcesFromApi.length) {
            this.exportOption = this.exportOption.map((option) => {
                if (option.type === 'IMAGE') {
                    let matchedResources: any[] = [];

                    if (option.key === 'PHOTO') {
                        matchedResources = photoResourcesFromApi.filter((res: any) => {
                            const resType =
                                res?.typeOfResourceInfo?.valeur ||
                                res?.typeOfResource?.valeur ||
                                res?.typeOfResource?.value ||
                                res?.typeOfResource;

                            const files = res?.file || res?.files || [];
                            return resType === 'PHOTO' && files?.[0]?.url;
                        });
                    } else {
                        // Các type khác: dùng resources từ fullExtendData
                        matchedResources = allResources.filter(
                            (res: any) => res.typeOfResource === option.key,
                        );
                    }

                    return {
                        ...option,
                        quantity: matchedResources.length,
                        items: matchedResources,
                    };
                }

                return option; // giữ nguyên các option khác
            });
        } else {
            this.exportOption = this.exportOption.map((option) => {
                if (option.type === 'IMAGE') {
                    return {
                        ...option,
                        quantity: 0,
                        items: [],
                    };
                }

                return option; // giữ nguyên các option khác
            });
        }

        this.exportOption = this.exportOption.map((item) => {
            if (item?.type === 'PDF' || item?.type === 'EXCEL') {
                // LOGISTIC_DATA sẽ được set từ API countLogisticsBattery, không set ở đây
                if (item?.key === 'LOGISTIC_DATA') {
                    return item;
                }
                // For other PDF/EXCEL types, use full length
                return {
                    ...item,
                    quantity: this.productExtendInfo?.length ?? 0,
                };
            }
            return item;
        });

        // Load logistics/battery quantity cho LOGISTIC_DATA
        this.loadLogisticsBatteryQuantity();

        this._commonService.getExtranetRestrictionsStore().subscribe((res) => {
            if (!res) return;

            const fonctions = res?.fonctions ?? [];
            const isPermissionImg = fonctions.includes('export-images');

            if (!isPermissionImg) {
                this.exportOption.forEach((el) => {
                    if (el.key === 'PHOTO') el.permission = false;
                });
            }

            Object.entries(functionToExportKey).forEach(([fonctionKey, exportKey]) => {
                this.updateExportPermission(fonctions, fonctionKey, exportKey);
            });

            // Options 'PHOTO' visible dés que HR ou LR est permis
            const hasPhotoPerm =
                fonctions.includes('export-photos-hd') || fonctions.includes('export-photos-bd');

            if (isPermissionImg)
                this.exportOption.forEach((el) => {
                    if (el.key === 'PHOTO') el.permission = hasPhotoPerm;
                });
        });
    }

    updateExportPermission(fonctions: string[], ref: string, key: string): void {
        const hasPermission = fonctions?.includes(ref) ?? true;
        this.exportOption.forEach((el) => {
            if (el.key === key) {
                el.permission = hasPermission;
            }
        });
    }

    /**
     * Load logistics/battery quantity for LOGISTIC_DATA export option
     * Gọi API countLogisticsBattery để lấy totalCount và set quantity
     */
    async loadLogisticsBatteryQuantity(): Promise<void> {
        try {
            // Kiểm tra có idProduct không
            if (!this.idProduct) {
                // Nếu không có idProduct, set quantity = 0 cho LOGISTIC_DATA
                this.exportOption = this.exportOption.map((item) => {
                    if (item?.key === 'LOGISTIC_DATA') {
                        return {
                            ...item,
                            quantity: 0,
                        };
                    }
                    return item;
                });
                return;
            }

            // Tạo body để gọi API countLogisticsBattery
            const currentLocale =
                environment.languagesExtranet.find(
                    (lang) => lang.code === this.translate.currentLang,
                )?.locale || 'en_GB';

            const body = {
                filters: [
                    {
                        fieldName: 'linkToParentProduct.documentId',
                        conditions: [
                            {
                                type: 'IN',
                                value: [this.idProduct],
                            },
                        ],
                    },
                ],
                fields: [
                    'id',
                    'longDescription',
                    'shortDescription',
                    'brand',
                    'packaging',
                    'standardNumberNf',
                    'state',
                    'linkToTariff',
                    'linkToRessources',
                    'description',
                    'referenceProduct',
                    'linkToParentProduct',
                    'namePartner',
                    'linkToTariff',
                    'countryOfManufacture',
                    'cutomsCode',
                    'gencodeProduct',
                    'specification',
                    'typeOfProduct',
                    'linkToCategories',
                    'categoryCode',
                    'department',
                    'orderNumber',
                    'statusProduct',
                ],
                locales: [currentLocale],
                sorts: {},
                page: 1,
                pageSize: 100,
            };

            // Gọi API countLogisticsBattery
            const response = await firstValueFrom(
                this.dynamicDocumentService.countLogisticsBattery(body, false),
            );

            // Update quantity cho LOGISTIC_DATA dựa trên totalCount
            if (response && response.totalCount !== undefined) {
                this.exportOption = this.exportOption.map((item) => {
                    if (item?.key === 'LOGISTIC_DATA') {
                        return {
                            ...item,
                            quantity: response.totalCount || 0,
                        };
                    }
                    return item;
                });
            }
        } catch (error) {
            console.error('Error loading logistics/battery quantity:', error);
            // Set quantity = 0 cho LOGISTIC_DATA nếu có lỗi
            this.exportOption = this.exportOption.map((item) => {
                if (item?.key === 'LOGISTIC_DATA') {
                    return {
                        ...item,
                        quantity: 0,
                    };
                }
                return item;
            });
        }
    }

    get isPermissionAllExport() {
        return this.exportOption.some((el) => el?.permission === true);
    }

    onShowModalAddition(value: { documentId: string }[], index: number, titleDialog: string) {
        this.dialogAdditionData = {
            ...this.dialogAdditionData,
            index: index,
            loading: true,
            titleDialog: titleDialog,
        };
        const ids = value?.map((el) => el?.documentId) ?? [];

        this.productRepository?.findByIds(ids).subscribe({
            next: (res) => {
                this.dialogAdditionData = {
                    loading: false,
                    visible: true,
                    data: res?.content,
                    index: null,
                    titleDialog: titleDialog,
                };
            },
            error: () => {
                this.dialogAdditionData.loading = false;
            },
        });
    }

    onRedirectToProductDetail(ref: string) {
        this.dialogAdditionData.visible = false;
        this.router.navigateByUrl(`product/detail/${ref}`);
        window.scrollTo(0, 0);
    }

    get getAdditionalInformationColumn() {
        return this.productExtendInfo?.some(
            (item) =>
                item.other ||
                (item.linkToTheReplacementArticle && item.linkToTheReplacementArticle.length > 0) ||
                (item.associatedProduct && item.associatedProduct.length > 0),
        );
    }

    hasAdditionalInformation(item: ProductExtendInfo): boolean {
        return (
            !!item.other ||
            (!!item.linkToTheReplacementArticle && item.linkToTheReplacementArticle.length > 0) ||
            (!!item.associatedProduct && item.associatedProduct.length > 0)
        );
    }

    /**
     * Kiểm tra xem có hiển thị Battery hay không
     */
    hasBatteryValue(info: ProductExtendInfo): boolean {
        if (!info) {
            return false;
        }

        const hasBattery = this.hasLanguagePropertyValue(info.battery);
        const hasBatteryWeight = info.batteryWeight != null && info.batteryWeight !== undefined;

        return hasBattery || hasBatteryWeight;
    }

    /**
     * Format giá trị Battery để hiển thị: "{battery} / {batteryWeight}g"
     * Nếu một trong hai field rỗng, dấu "/" sẽ biến mất
     */
    getBatteryValue(info: ProductExtendInfo): string {
        if (!info) {
            return '';
        }

        const batteryText = info.battery
            ? this.translateDynamicLanguage.transform(info.battery)
            : '';
        const batteryWeightText =
            info.batteryWeight != null && info.batteryWeight !== undefined
                ? `${info.batteryWeight}g`
                : '';

        if (batteryText && batteryWeightText) {
            return `${batteryText} / ${batteryWeightText}`;
        } else if (batteryText) {
            return batteryText;
        } else if (batteryWeightText) {
            return batteryWeightText;
        }

        return '';
    }

    /**
     * Kiểm tra xem LanguageProperty có giá trị hay không
     */
    private hasLanguagePropertyValue(field: any): boolean {
        if (!field) {
            return false;
        }

        if (typeof field === 'string') {
            return field.trim() !== '';
        }

        if (typeof field === 'object') {
            const values = Object.values(field);
            return values.some((value: any) => value != null && String(value).trim() !== '');
        }

        return false;
    }
}
